import gql from 'graphql-tag';

export default class FileFragments {
  static file = gql`
    fragment fileFragment on File {
      id
      name
      participantId
      createdAt
      extension
      pinned
      pinnedAt
      source
      status
      size
    }
  `;
}
